import React, { forwardRef } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { animations } from "helpers/animations";
import CancelIcon from "@material-ui/icons/Cancel";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { SubmitBtns } from "components/CustomButtons/SubmitBtns";
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";

export const ModalContent = forwardRef((props) => {
  const {
    onClose,
    children,
    title,
    toRight,
    isLoading = false,
    loading = false,
    hideContentOnLoading = true,
    isLarge = false,
    minHeight = 0,
    textMargin = 0,
    textAlign = "start",
    halfScreen,
    customWidth = "50%",
    isMap = false,
    submitBtnText = "Confirmar",
    confirmColor = "info",
    cancelColor = "transparent",
    cancelText = "Cancelar",
    onSubmit = null,
    disabledBtn = false
  } = props;
  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down("md"));
  const { isDark } = useThemeMode();
  const style = {
    width: isTabletOrSmaller
      ? "100%"
      : halfScreen
        ? "50%"
        : toRight
          ? "35%"
          : customWidth,
    minHeight: toRight ? "100vh" : minHeight ? minHeight : 350,
    backgroundColor: isDark ? darkPalette.cardBg : "white",
    color: isDark ? darkPalette.textPrimary : "inherit",
    padding: 20,
    position: toRight ? "absolute" : "relative",
    top: 0,
    right: 0,
    borderTopRightRadius: toRight && 0,
    borderBottomRightRadius: toRight && 0,
    borderRadius: !toRight ? 10 : "",
    zIndex: 9998,
    animationDuration: ".3s",
  };
  const large = {
    ...style,
    width: isTabletOrSmaller ? "100%" : "45%",
  };
  const typeMap = {
    ...style,
    width: "50vw",
  };
  return (
    <>
      <Box
        className={animations.fadeIn}
        style={isLarge ? large : isMap ? typeMap : style}
        tabIndex={-1}
      >
        <Box style={{
          position: "absolute",
          top: 10,
          right: 10,
        }}>
          <RegularButton
            color="transparent"
            round
            justIcon
            // size="sm"
            onClick={onClose}
            tooltip="Cerrar"
            disabled={isLoading || loading}
          >
            <CancelIcon style={{ color: "#f6685e" }} />
          </RegularButton>
        </Box>
        <Typography
          component="h2"
          variant="h5"
          color="primary"
          style={{ margin: textMargin, marginBottom: 45, textAlign }}
        >
          {title}
        </Typography>
        {(isLoading || loading) && hideContentOnLoading ? (
          <LoadingComponent />
        ) : (
          <Grid
            container
            spacing={2}
            className={animations.fadeIn}
            style={{ animationDelay: ".5s" }}
          >
            {children}
          </Grid>
        )}
        {onSubmit && (
          <SubmitBtns
            onClose={onClose}
            onSubmit={onSubmit}
            loading={isLoading}
            submitBtnText={submitBtnText}
            confirmColor={confirmColor}
            cancelColor={cancelColor}
            cancelText={cancelText}
            disabled={disabledBtn}
          />
        )}
      </Box>
    </>
  );
});
